import React, { FC } from 'react';
import NumberFormat from 'react-number-format';
import { TextField } from '@material-ui/core';

const InputSeparator: FC<any> = ({ inputRef, type, name, id, className, placeholder, onChange, value, defaultValue, center, variant, size, maxLength }) => {

    const valid = (e: any) => {
        if (maxLength) {
            if (e.target.value.length <= maxLength) handleChange(e);
        } else {
            handleChange(e);
        }
    };

    const handleChange = (event: any) => {
        onChange(event)
    };

    return (
        // @ts-ignore
        <NumberFormat
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: name,
                        value: values.value,
                    },
                });
            }}
            className={`w-100 ltr ${className} ${center && 'centerinput'}`}
            // @ts-ignore
            value={value}
            renderText={(props: any) => (
                <TextField
                    {...props}
                    size={size}
                    inputRef={inputRef}
                    variant={variant}
                    type={type}
                    id={id}
                    placeholder={placeholder}
                    defaultValue={defaultValue}
                    onChange={valid}
                    aria-autocomplete={'none'}
                    autoComplete={'false'}
                    name={name}
                />
            )}
            maxLength={maxLength}
            thousandSeparator
            isNumericString
        />
    );
}

export default InputSeparator